import { useCallback } from "react";

import {
  ensureClientSettingsHydrated,
  getClientSettingsHydrationStatus,
  persistClientSettingsUpdate,
} from "../hooks/useSettings";

/**
 * Marks first-run onboarding finished (or skipped) so FirstRunGate never
 * routes to the welcome wizard again. The gate itself lives in
 * `components/onboarding/FirstRunGate.tsx`. Ported from upstream
 * `apps/web/src/onboarding/firstRun.ts` onto forge's client-settings
 * persistence.
 */
export function useCompleteOnboarding(): () => Promise<void> {
  return useCallback(async () => {
    await ensureClientSettingsHydrated();
    if (getClientSettingsHydrationStatus() !== "ready") {
      // A failed read leaves the snapshot at defaults; persisting now would
      // overwrite every saved preference with them. Refuse so the wizard
      // stays open and reports the failure; a retry re-runs the read.
      throw new Error("Client settings are not hydrated; refusing to overwrite them.");
    }
    const onboardingCompletedAt = new Date().toISOString();
    await persistClientSettingsUpdate((current) => ({ ...current, onboardingCompletedAt }));
  }, []);
}
